// removed by extract-text-webpack-plugin
module.exports = {"comparison-price-container":"ComparisonPrice__comparison-price-container","comparisonPriceContainer":"ComparisonPrice__comparison-price-container","price-text":"ComparisonPrice__price-text","priceText":"ComparisonPrice__price-text","link":"ComparisonPrice__link","price-sm":"ComparisonPrice__price-sm","priceSm":"ComparisonPrice__price-sm"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonPrice/ComparisonPrice.mobile.css
// module id = 1326
// module chunks = 8